import { render, staticRenderFns } from "./RiderDeliveries.vue?vue&type=template&id=3aa41128&scoped=true"
import script from "./RiderDeliveries.vue?vue&type=script&lang=js"
export * from "./RiderDeliveries.vue?vue&type=script&lang=js"
import style0 from "./RiderDeliveries.vue?vue&type=style&index=0&id=3aa41128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa41128",
  null
  
)

export default component.exports